module.exports = __webpack_public_path__ + "static/media/img_top_main1@3x.5771fc3b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_top_main1@3x.webp
// module id = 774
// module chunks = 0